import './index.scss'
import '@engie-group/fluid-design-tokens/lib/css/tokens.css'
import '@engie-group/fluid-design-system/lib/base.css'
import { App } from 'App'
import { BrowserRouter } from 'react-router-dom'
import React from 'react'
import ReactDOM from 'react-dom/client'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
